import React, { useState, useEffect } from "react";
import { Form } from "react-formio";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { getUserSurveyFormPreview } from "../../Utils/userFunctions";
import { surveyDraftandreportRejection } from "../../Utils/adminFunctions";
import { ToastContainer, toast } from "react-toastify";
import ScaleLoader from "react-spinners/ScaleLoader";
let UserSurveyFormView = () => {
  const { surveyID } = useParams();
  const navigate = useNavigate();
  const [surveyName, setSurveyName] = useState("");
  const [formJson, setFormJson] = useState([]);
  const [surveyStatus, setSurveyStatus] = useState([]);
  const [companyLogo, setCompanyLogo] = useState();
  const [participantQualification, setParticipantQualification] =
    useState(false);
  const [consent, setConsent] = useState();
  const [consentStatementShow, setConsentStatementShow] = useState(false);

  const [desabledBtn, setDesabledBtn] = useState(false);
  const [isCheckedUser, setIsCheckedUser] = useState(false);
  const [isNotifyUser, setIsNotifyUser] = useState(false);
  const [isCheckedAccess, setIsCheckedAccess] = useState(false);

  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    getSurveyFormPreview();
  }, []);

  const getSurveyFormPreview = async () => {
    const response = await getUserSurveyFormPreview(surveyID);
    if (response.status == "success") {
      const filter1 = response.data.data[0].form_json.replace(
        /"true"/g,
        "true"
      ); // replace true
      const filter2 = filter1.replace(/"false"/g, "false"); // replace false
      const finalJson = filter2.replace(/"null"/g, "null"); // replace false
      setIsNotifyUser(response.data.isNotifyUser);
      setIsCheckedUser(response.data.isCheckedUser);
      setIsCheckedAccess(response.data.isCheckedAccess);
      setSurveyName(response.data.data[0].survey_name);
      const formJSON = JSON.parse(finalJson)?.map(( item,index )=> {
        if(item.label?.toLowerCase() !== "submit"){
          return ({...item, label:`${index+1}. ${item.label}`})
        } else return item
      })
      setFormJson(formJSON);
      setSurveyStatus(response.data.data[0].status);
      setCompanyLogo(response.data.data[0].manufacturer__company_logo);
      if (response.data.data[0].participant_qualification == "yes") {
        setParticipantQualification(true);
      }
      setConsent(response.data.data[0].consent_statement);
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };

  const handleRejectSurveyStatus = async (surveyStatus) => {
    setDesabledBtn(true);
    if (message === "") {
      setErrorMessage("Can not be empty");
      setDesabledBtn(false);
      return false;
    } else {
      const status = surveyStatus == "draft_rejected" ? "rejected" : "approved";
      const bodyFormData = new FormData();
      bodyFormData.append("survey_id", surveyID);
      bodyFormData.append("comment", message);
      bodyFormData.append("status", status);
      bodyFormData.append("action", surveyStatus);
      const response = await surveyDraftandreportRejection(bodyFormData);
      if (response.status == "success") {
        document.querySelector(".close_popup").click();
        document.querySelector(".close_popup_reject").click();
        getSurveyFormPreview();
        setDesabledBtn(false);
        toast.success(response.message, { autoClose: 1500 });
        navigate(-1);
      //  navigate("/survey-draft-approval")
      } else {
        setDesabledBtn(false);
        toast.warning(response.message, { autoClose: 1500 });
      }
    }
  };
  const handleConsentStatementShow = () => {
    setConsentStatementShow(true);
  };
  const handleconsentStatementClose = () => {
    setConsentStatementShow(false);
  };
  return (
    <>
       {desabledBtn&&(
        <div style={{
          zIndex:100000,
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
          position: "fixed",
         inset:0,
          backgroundColor: 'rgba(86, 86, 86, 0.8)'
        }}>
        <ScaleLoader
  color="#F58634"
  height={100}
  margin={5}
  radius={8}
  width={20}
/>
        </div>
      )}
      
      <div className="modal fade show" id="approve_draft" arial-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Approve survey draft?</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label for="validationTextarea" className="form-label">
                  Comments:
                </label>

                <textarea
                  className={
                    "form-control" + (errorMessage ? " is-invalid" : "")
                  }
                  id="message-text"
                  onChange={(e) => {
                    setMessage(e.target.value);
                    setErrorMessage("");
                  }}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-sm btn-dark close_popup"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm custom-btn-primary"
                onClick={() => {
                  handleRejectSurveyStatus("draft_approved");
                }}
                disabled={desabledBtn}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade show" id="reject_draft" arial-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Reject survey draft?</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label for="validationTextarea" className="form-label">
                  Comments:
                </label>

                <textarea
                  className={
                    "form-control" + (errorMessage ? " is-invalid" : "")
                  }
                  id="message-text"
                  onChange={(e) => {
                    setMessage(e.target.value);
                    setErrorMessage("");
                  }}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-sm btn-dark close_popup_reject"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm custom-btn-primary"
                onClick={() => {
                  handleRejectSurveyStatus("draft_rejected");
                }}
                disabled={desabledBtn}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
      <section className="query-form-section">
        <div className="container pt-2">
          <div className="create-question-header">
            <div className="row">
              <div className="col-md-12 text-center">
                <img
                  src={companyLogo}
                  alt="image not available"
                  style={{ maxHeight: "40px", minHeight: "40px" }}
                ></img>
              </div>
            </div>
            <div className="row align-items-center mt-4">
              <div
                className="col-md-12 text-center"
                style={{ fontSize: "18px" }}
              >
                <strong>{surveyName}</strong>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 mb-2">
              {participantQualification && (
                <Link
                  to={"/survey-form/participant-qualification/" + surveyID}
                  className="btn btn-sm custom-btn-primary mr-2"
                >
                  Participant Qualification
                </Link>
              )}
              {consent} 
              {(localStorage.getItem("user_type") == 3 ||
                localStorage.getItem("user_type") == 2) && (
                <>
                  <Link
                    to={"/UserSurveyDetails/" + surveyID}
                    className="btn btn-sm custom-btn-primary pull-right"
                  >
                    <i className="fa fa-arrow-left"></i> Back
                  </Link>
                </>
              )}
              {localStorage.getItem("user_type") == 5 && (
                <>
                  <Link
                    to={"/survey-draft-approval"}
                    className="btn btn-sm custom-btn-primary pull-right"
                  >
                    <i className="fa fa-arrow-left"></i> Back
                  </Link>
                </>
              )}
            </div>
          </div>
          <div className="query-form-info">
            <div className="row form-box-top-margin">
              <div className="col-md-12">
                <div className="form-box_preview disabled_form_submit">
                  <Form
                    src={{
                      display: "form",
                      components: formJson,
                    }}
                    options={{ readOnly: false }}
                  />
                  <button
                    className="btn btn-md custom-btn-primary custom_disabled_btn"
                    disabled
                  >
                    Submit
                  </button>
                </div>
                <div>
                  <center>
                    {isNotifyUser == true && isCheckedAccess == true && (
                      <>
                        {surveyStatus == "draft_released"
                          ? isCheckedUser == false && (
                              <>
                                <Link
                                  to="#"
                                  className="btn text-white btn-sm custom-btn-primary mr-2"
                                  data-toggle="modal"
                                  data-target="#approve_draft"
                                >
                                  <i className="fa fa-check-square-o"></i>
                                  Approve Draft
                                </Link>

                                <Link
                                  to="#"
                                  className="btn btn-danger btn-sm"
                                  data-toggle="modal"
                                  data-target="#reject_draft"
                                >
                                  <i className="fa fa-close (alias)"></i>
                                  Reject Draft
                                </Link>
                              </>
                            )
                          : ""}
                      </>
                    )}
                  </center>
                </div>
              </div>
            </div>
          </div>
          <Modal
            show={consentStatementShow}
            onHide={handleconsentStatementClose}
            animation={false}
            className="cmpopup"
          >
            <Modal.Header className="contentBopup">
              <h5>
                <b>Consent</b>
              </h5>
            </Modal.Header>
            <Modal.Body>
              <p>{consent}</p>
            </Modal.Body>
          </Modal>
        </div>
      </section>
    </>
  );
};

export default UserSurveyFormView;
